import logo from './logo.svg';
import './App.css';
import CardView from './components/Cards/CardView';

function App() {
  return (
    <div className="App">
      <CardView/>
    </div>
  );
}

export default App;
